import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted);

var service = {};
var enableHeartbeat = true;

// These functions touch the DOM, and they shouldn't...
// TODO: Move this in to veu somehow
function hideAPICurtain () {
  document.getElementById('loader_cover').style.opacity = 0.9;
  document.getElementById('loader_cover').style.height = 0;
}

function showAPICurtain (message) {
  if (!message) {
    message = 'Connection error!';
  }
  document.getElementById('loader_cover_message').innerHTML =
    '<div style="text-align: center; margin: 48px"><div style="font-size: 100px; color: #888888; border: 7px solid #888888; border-radius: 50%; height: 100px; width: 100px; display: inline-block; vertical-align: middle; padding-top: 34px">!</div></div>' +
    message + '<br/>Please refresh';
  document.getElementById('initial_loader_spinner').style.display = 'none';
  document.getElementById('loader_cover').style.height = '100%'
}

var websocket = null;

var primerRequest;
if (window.XMLHttpRequest) { // Mozilla, Safari, ...
  primerRequest = new XMLHttpRequest();
} else if (window.ActiveXObject) { // IE
  try {
    primerRequest = new ActiveXObject('Msxml2.XMLHTTP'); // eslint-disable-line no-undef
  } catch (e) {
    try {
      primerRequest = new ActiveXObject('Microsoft.XMLHTTP'); // eslint-disable-line no-undef
    } catch (e) {
    }
  }
}
primerRequest.onreadystatechange = function () {
  if (primerRequest.readyState === 4) { // done
    if (primerRequest.status === 200) { // complete
      websocket = new WebSocket((location.protocol === "https:" ? "wss://" : "ws://") + location.host + '/api/ws');
      websocket.onerror = function (error) {
        if (error) {
          console.log(error.stack)
        }
        handleWSClose();
      };

      websocket.onclose = function (message) {
        var messageText;
        if (message.reason) {
          messageText = message.reason;
        }
        handleWSClose(messageText)
      };

      websocket.onopen = function () {
        service.subscribe("SESSION", "0000000000000000000000", handleSessionNotification);
        if (enableHeartbeat) {
          heartbeat = setInterval(() => {
            websocket.send("h");
          }, 25000);
        }
      };

      websocket.onmessage = function (event) {
        var message = JSON.parse(event.data)

        if (message.type === 'PUBLISH') {
          if (message.subscriptionId < 0) {
            displayErrorMessage(message.data);
          } else {
            handlePublish(message.subscriptionId, message.data)
          }
        } else if (message.type === 'RESPONSE') {
          if (message.requestId >= 0) {
            handleResponse(message)
          }
        }
      };
    }
  }
};
primerRequest.open("GET", "/api/primer");
primerRequest.send(null);

var websocketMessageCount = 0;
var requestSuccessCallbacks = {};
var requestFailureCallbacks = {};

var sessionHandler;
var activeRequests = 0;
var requestCountChangeHandler;

service.setSessionHandler = function (handler) {
  sessionHandler = handler
};

service.setRequestCount = function (handler) {
  requestCountChangeHandler = handler
};

service.rpcRequest = rpcRequest;

function handleWSClose(message) {
  showAPICurtain(message);
  if (heartbeat !== undefined) {
    clearInterval(heartbeat);
  }
}

var heartbeat;

function handleResponse (response) {
  var successCallback = requestSuccessCallbacks[response.requestId];
  delete requestSuccessCallbacks[response.requestId];
  var failureCallback = requestFailureCallbacks[response.requestId];
  delete requestFailureCallbacks[response.requestId];

  activeRequests = activeRequests - 1;
  if (requestCountChangeHandler) {
    requestCountChangeHandler(activeRequests)
  }

  if (response.success) {
    successCallback(response.response)
  } else {
    displayErrorMessage(response.errorMessage);
    failureCallback(response.errorMessage)
  }
}

function handleSessionNotification (newSession) {
  hideAPICurtain();
  if (sessionHandler) {
    sessionHandler(newSession)
  }
}

function rpcRequest (method, parameters, successCallback, failureCallback) {
  var requestId = (websocketMessageCount++);

  if (successCallback === undefined || successCallback === null) {
    successCallback = function (change) {
    };
  }
  if (failureCallback === undefined || failureCallback === null) {
    failureCallback = function (change) {
    };
  }

  requestSuccessCallbacks[requestId] = successCallback;
  requestFailureCallbacks[requestId] = failureCallback;

  activeRequests = activeRequests + 1;
  if (requestCountChangeHandler) {
    requestCountChangeHandler(activeRequests)
  }

  websocket.send(
    JSON.stringify({
      type: 'REQUEST',
      requestId: requestId,
      method: method,
      parameters: parameters
    })
  )
}

service.rpcFireAndForget = function(method, parameters) {
  websocket.send(
    JSON.stringify({
      type: 'REQUEST',
      requestId: -1,
      method: method,
      parameters: parameters
    })
  )
};

var subscriptionCount = 0;
var subscriptionHandlers = {};

service.subscribe = function(topicType, topicId, changeHandler) {
  var subscriptionId = subscriptionCount;
  subscriptionCount = subscriptionCount + 1;

  if (changeHandler === undefined || changeHandler === null) {
    changeHandler = function (change) {
    };
  }

  subscriptionHandlers[subscriptionId] = changeHandler;

  websocket.send(
    JSON.stringify({
      type: 'SUBSCRIBE',
      subscriptionId: subscriptionId,
      topic: {
        type: topicType,
        id: topicId
      }
    })
  );

  return subscriptionId;
};

service.unsubscribe = function(subscriptionId) {
  websocket.send(
    JSON.stringify({
      type: 'UNSUBSCRIBE',
      subscriptionId: subscriptionId
    })
  );

  delete subscriptionHandlers[subscriptionId];
};

function handlePublish (subscriptionId, data) {
  var handler = subscriptionHandlers[subscriptionId];

  if (handler) {
    handler(data);
  } else {
    console.dir("WARNING: Received publish without subscription - " + subscriptionId);
    console.dir(data);
  }
}

function displayErrorMessage(errorMessage) {
  Vue.toasted.error('Error: ' + errorMessage, {
    duration: 8000
  });
}

export default service



// WEBPACK FOOTER //
// ./src/api.js